import styled from 'styled-components';
import { theme } from '../../../theme';

export const SpanDescription = styled.span`
  margin-left: 0.538rem;
  color: ${theme.colors.secondary};
  cursor: pointer;
`;

export const DivWrapper = styled.div`
  display: flex;
  align-items: center;
`;
